import {createSelector} from 'reselect';

export const getUpdateSystemStore = (state) => state.updateSystemStore;

export const getUpdateSWStatus = createSelector(
  [getUpdateSystemStore],
  (updateSystemStore) => updateSystemStore.updateSWStatus,
);
